import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import AccordionDetails from "@mui/material/AccordionDetails";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useLocation } from "react-router-dom";
import {
  casdoorApi,
  useGetUserRolesQuery,
} from "entitites/casdoor/api/casdoorApi";
import { Roles } from "entitites/casdoor/model/casdoor";
import { useAppDispatch } from "shared/libs/redux";
import { Skeleton } from "@mui/material";
import { Dispatch, SetStateAction } from "react";

export const AccessesBody = ({
  edit,
  setIsDirty,
}: {
  edit: boolean;
  setIsDirty: Dispatch<SetStateAction<boolean>>;
}) => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { data: roles } = useGetUserRolesQuery(location.pathname.split("/")[2]);
  const prepareData = (roles: Roles[]) => {
    return roles.reduce((r: { [key: string]: Roles[] }, cur) => {
      const key = cur.domains.toString();
      (r[key] = r[key] || []).push(cur);
      return r;
    }, {});
  };
  if (!roles) {
    return (
      <>
        <Skeleton variant="rounded" height={130} sx={{ mb: 2 }}></Skeleton>
        <Skeleton variant="rounded" height={214} sx={{ mb: 2 }}></Skeleton>
        <Skeleton variant="rounded" height={163}></Skeleton>
      </>
    );
  }

  return (
    <div>
      {Object.keys(prepareData(roles)).map((domain) => (
        <Accordion
          defaultExpanded
          key={domain}
          sx={{ bgcolor: "background.default" }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
            sx={{ fontWeight: 500 }}
          >
            {domain || "Без группы"}
          </AccordionSummary>
          <AccordionDetails>
            <FormGroup
              sx={{ ml: 2, display: "flex", flexDirection: "column" }}
              aria-label="position"
              row
            >
              {prepareData(roles)[domain].map((role) => (
                <FormControlLabel
                  key={role.createdTime}
                  value="top"
                  control={
                    <Checkbox
                      onChange={(_, value) => {
                        setIsDirty(true);
                        dispatch(
                          casdoorApi.util.updateQueryData(
                            "getUserRoles",
                            location.pathname.split("/")[2],
                            (data) => {
                              data[
                                data.findIndex(
                                  (item) => item.name === role.name
                                )
                              ].isChecked = value;

                              return data;
                            }
                          )
                        );
                      }}
                      checked={role.isChecked}
                      disabled={!edit}
                    />
                  }
                  label={role.displayName}
                  labelPlacement="end"
                />
              ))}
            </FormGroup>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
};
